export default __webpack_public_path__ + "static/media/kbank.7415ea57.svg";